import {
    BulkGlossaryUploadIcon as ImportGlossaryIcon,
    GlossaryMetadataEmptyStateIcon as AddGlossaryIcon,
} from '../../../../assets';

export const glossaryMetadataConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'create-glossary': {
        imgSrc: AddGlossaryIcon,
        headingText: 'New Glossary',
        iconStyles: {
            width: '68px',
            height: '71.84px',
        },
    },
    'import-glossary': {
        imgSrc: ImportGlossaryIcon,
        headingText: 'Import Glossary',
        iconStyles: {
            height: '75px',
            width: '70.99px',
        },
    },
};
